import ListGroup from "../generic/list-group";
import ListItem from "./sql-list-item";

const DEFAULTS = {
  childView: ListItem,
};

class View extends ListGroup {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }
}

export { View as default };
